export default __webpack_public_path__ + "static/media/StarClub@2x.6b1cf9e0.png";